<template>
    <app-layout>
        <template v-slot:header>
            <h2 class="font-bold text-4xl dark:text-gray-200">
                Edit user
            </h2>
        </template>

        <div>
            <jet-form-card @submitted="submit">
                <template #form>
                    <div class="col-span-6">
                        <jet-label for="name" value="Name"/>
                        <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" required
                                   :error="!!form.errors.name"
                                   autofocus/>
                        <jet-input-error :message="form.errors.name"/>
                    </div>

                    <div class="col-span-6">
                        <jet-label for="email" value="Email"/>
                        <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required
                                   :error="!!form.errors.email"
                                   autofocus/>
                        <jet-input-error :message="form.errors.email"/>
                    </div>

                    <div class="col-span-6">
                        <jet-label for="password" value="Password"/>
                        <jet-input :disabled="form.id === $page.props.user.id" id="password" type="password"
                                   :error="!!form.errors.password"
                                   autocomplete="new-password"
                                   class="mt-1 block w-full" v-model="form.password"/>
                        <jet-input-error :message="form.errors.password"/>
                    </div>

                    <div class="col-span-6" v-if="form.id !== $page.props.user.id">
                        <jet-label value="Roles"/>
                        <div class="mt-2">
                            <template v-for="(role, index) in roles">
                                <jet-radio name="role" :disabled="true" :class="{'ml-6': index}" :value="role.id"
                                              v-model:checked="form.role">
                                    {{ role.name }}
                                </jet-radio>
                            </template>
                        </div>
                        <jet-input-error :message="form.errors.role"/>
                    </div>

                    <template v-if="form.role !== 1">
                        <div class="col-span-6">
                            <jet-label class="block mt-4 text-sm" value="Organization"></jet-label>
                            <jet-input
                                type="text"
                                name="organization[name]"
                                class="block w-full"
                                placeholder=""
                                v-model="form.organization.name"
                                required
                                autofocus
                                autocomplete="name"/>
                            <jet-input-error :message="form.errors['organization.name']"/>
                        </div>
                    </template>

                    <div class="col-span-6">
                        <jet-label for="active" value="Active"/>
                        <jet-select id="active" v-model:selected="form.active" :error="!!form.errors.active">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </jet-select>
                        <jet-input-error :message="form.errors.active"/>
                    </div>
                </template>
                <template #actions>
                    <jet-action-message :on="form.recentlySuccessful" class="ml-auto mr-3">
                        Saved.
                    </jet-action-message>
                    <jet-button :class="{ 'opacity-25': form.processing }"
                                :disabled="form.processing"
                                :bg-dark="true"
                    >
                        Save
                    </jet-button>
                </template>
            </jet-form-card>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import JetInput from '@/Jetstream/Input';
import JetButton from '@/Jetstream/Button';
import JetLabel from '@/Jetstream/Label';
import JetRadio from '@/Jetstream/Radio';
import JetSelect from '@/Jetstream/Select';
import JetFormCard from '@/Jetstream/FormCard';
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetInputError from '@/Jetstream/InputError';

export default {
    components: {
        AppLayout,
        JetInput,
        JetLabel,
        JetButton,
        JetRadio,
        JetSelect,
        JetFormCard,
        JetActionMessage,
        JetInputError,
    },
    props: {
        userModel: Object,
        roles: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.userModel.name,
                password: '',
                email: this.userModel.email,
                role: this.userModel.roles[0].id,
                organization: {
                    name: this.userModel.tenant ? this.userModel.tenant.name : '',
                },
                active: !!this.userModel.active,
            }),
        }
    },

    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                }))
                .patch(this.route('admin.users.update', this.userModel.id), {
                    onFinish: () => this.form.reset('password'),
                })
        },
    }
}
</script>
